import TableDefinitionModel from './models/TableDefinitionModel';
import {
  apiFetchMrdMonitoringReportsAllMRDs,
} from '../application/mrd-monitoring/all-mrds/api/MrdMonitoringReportsAllMRDsAPI';
import { apiFetchMrdMonitoringReportsAllIssues } from '../application/mrd-monitoring/all-issues/api/MrdMonitoringReportsAllIssuesAPI';
import { apiFetchMrdMonitoringReportsReportedByUser } from '../application/mrd-monitoring/reported-by-user/api/MrdMonitoringReportsReportedByUserAPI';
import { apiFetchMrdMonitoringReportsXmlDelayed } from '../application/mrd-monitoring/xml-delayed/api/MrdMonitoringReportsXmlDelayedAPI';
import { apiFetchMrdMonitoringReportsNoSync } from '../application/mrd-monitoring/no-sync/api/MrdMonitoringReportsNoSyncAPI';
import { apiFetchDenestImpcMapping } from '../application/mrd-administration/impc-mapping/api/DenestImpcMappingAPI';
import {
  apiFetchInactiveMrdList,
  apiFetchMrdList,
} from '../application/mrd-administration/device-information/api/DeviceInformationAPI';
import { apiFetchIATAList, apiFetchFlightList } from '../application/mrd-administration/flight-information/api/FlightInformationAPI';
import {
  apiFetchMrdDeviceListByCountry,
  apiFetchMrdHandlers,
} from '../application/mrd-administration/handlers/api/HandlersAPI';
import { apiFetchHandlerListByImpc } from '../application/mrd-administration/device-information/associate-handler/api/AssociateHandlerAPI';
import { apiFetchMrdSettingsList } from '../application/mrd-administration/device-settings/api/DeviceSettingsAPI';
import {
  apiFetchIpcContacts,
  apiFetchMrdContacts,
  apiFetchMrdContactsDefault,
  apiFetchXmlContacts,
} from '../application/mrd-administration/contact-management/api/MrdContactsAPI';
import {
  apiFetchAllContacts,
  apiFetchMrdContactList,
} from '../application/mrd-administration/device-information/contact-management/api/ContactManagementAPI';
import { apiFetchImpcsWithMrdsDefault } from './impc/api/ImpcAPI';
import { apiFetchNotificationServiceThreshold } from '../application/mrd-administration/notification-service/api/NotificationServiceThresholdAPI';
import { apiFetchMrdAppTranslations } from '../application/mrd-administration/translations/api/MrdAppTranslationsAPI';
import { DataSharingAPI } from '../application/mrd-administration/data-sharing/api/DataSharingAPI';

export default {
  MRD_MONITORING_REPORT_ALL_MRDS: new TableDefinitionModel(
    'MRD_MONITORING_REPORT_ALL_MRDS',
    apiFetchMrdMonitoringReportsAllMRDs,
  ),
  MRD_MONITORING_REPORT_ALL_ISSUES: new TableDefinitionModel(
    'MRD_MONITORING_REPORT_ALL_ISSUES',
    apiFetchMrdMonitoringReportsAllIssues,
  ),
  MRD_MONITORING_REPORT_REPORTED_BY_USER: new TableDefinitionModel(
    'MRD_MONITORING_REPORT_REPORTED_BY_USER',
    apiFetchMrdMonitoringReportsReportedByUser,
  ),
  MRD_MONITORING_REPORT_XML_DELAYED: new TableDefinitionModel(
    'MRD_MONITORING_REPORT_XML_DELAYED',
    apiFetchMrdMonitoringReportsXmlDelayed,
  ),
  MRD_MONITORING_REPORT_NO_SYNC: new TableDefinitionModel(
    'MRD_MONITORING_REPORT_NO_SYNC',
    apiFetchMrdMonitoringReportsNoSync,
  ),
  MRD_DENEST_IMPC_MAPPING: new TableDefinitionModel(
    'MRD_DENEST_IMPC_MAPPING',
    apiFetchDenestImpcMapping,
  ),
  MRD: new TableDefinitionModel(
    'MRD',
    apiFetchMrdList,
  ),
  MRD_INACTIVE: new TableDefinitionModel(
    'MRD_INACTIVE',
    apiFetchInactiveMrdList,
  ),
  MRD_ADMINISTRATION_IATA: new TableDefinitionModel(
    'MRD_ADMINISTRATION_IATA',
    apiFetchIATAList,
  ),
  MRD_ADMINISTRATION_FLIGHTS: new TableDefinitionModel(
    'MRD_ADMINISTRATION_FLIGHTS',
    apiFetchFlightList,
  ),
  MRD_DEVICE_LIST_BY_COUNTRY: new TableDefinitionModel(
    'MRD_DEVICE_LIST_BY_COUNTRY',
    apiFetchMrdDeviceListByCountry,
  ),
  HANDLERS_BY_MRD_DEVICE: new TableDefinitionModel(
    'HANDLERS_BY_MRD_DEVICE',
    apiFetchMrdHandlers,
  ),
  HANDLERS_BY_IMPC: new TableDefinitionModel(
    'HANDLERS_BY_IMPC',
    apiFetchHandlerListByImpc,
  ),
  MRD_SETTINGS: new TableDefinitionModel(
    'MRD_SETTINGS',
    apiFetchMrdSettingsList,
  ),
  MRD_CONTACTS_PAGE: new TableDefinitionModel(
    'MRD_CONTACTS_PAGE',
    apiFetchMrdContactsDefault,
  ),
  IPC_CONTACTS: new TableDefinitionModel(
    'IPC_CONTACTS',
    apiFetchIpcContacts,
  ),
  MRD_CONTACTS: new TableDefinitionModel(
    'MRD_CONTACTS',
    apiFetchMrdContacts,
  ),
  XML_CONTACTS: new TableDefinitionModel(
    'XML_CONTACTS',
    apiFetchXmlContacts,
  ),
  MRD_CONTACTS_WIZARD: new TableDefinitionModel(
    'MRD_CONTACTS_WIZARD',
    apiFetchMrdContactList,
  ),
  MRD_IMPC_LIST_BY_COUNTRY: new TableDefinitionModel(
    'MRD_IMPC_LIST_BY_COUNTRY',
    apiFetchImpcsWithMrdsDefault,
  ),
  ALL_CONTACTS: new TableDefinitionModel(
    'ALL_CONTACTS',
    apiFetchAllContacts,
  ),
  NOTIFICATION_SERVICE_THRESHOLD: new TableDefinitionModel(
    'NOTIFICATION_SERVICE_THRESHOLD',
    apiFetchNotificationServiceThreshold,
  ),
  MRD_APP_TRANSLATIONS: new TableDefinitionModel(
    'MRD_APP_TRANSLATIONS',
    apiFetchMrdAppTranslations,
  ),
  DATA_SHARING_VIEW: new TableDefinitionModel(
    'DATA_SHARING_VIEW',
    DataSharingAPI,
  ),
};
